import React from 'react'
import  './index.less'
import Zoom from './touch'
import { connect } from 'dva'

const maskLayer = React.createRef();
const img = React.createRef();
class ZoomImg extends React.PureComponent {
  /**
   * 关闭会话
   */
  onClose = () => {
    this.props.dispatch({
      type: 'leaveMsg/update',
      payload: { zoomImgDisplay: false, zoomImgSrc: '' }
    })
  }
  render() {
    const { type, leaveMsg: { zoomImgSrc, zoomImgDisplay } } = this.props;
    return (
      <div className='zc-zoom-img-container'
        ref={maskLayer}
        style={{ zIndex: +new Date(), display: zoomImgDisplay ? 'block' : 'none' }}>
        <div className='content' onClick={this.onClose}>
          <svg className='closeBtn' aria-hidden="true" width="15" height="15">
            <use xlinkHref="#iconguanbi2" />
          </svg>
          <div className='imgWrap'>
            <img className={`img ${type === 'pc'? 'pc-img': ''}`}
              ref={img}
              src={zoomImgSrc}
              alt=""
               onLoad={
                () => {
                  Zoom.init(maskLayer.current, img.current)
                }
              } 
            />
          </div>
        </div>
      </div>
    )
  }
}
export default connect(({ leaveMsg }) => ({ leaveMsg }))(ZoomImg)